export default __webpack_public_path__ + "static/media/logo_a.fcbb5970.svg";